<template>
  <v-dialog v-model="value" scrollable persistent style=" max-width: 1000px">
    <v-card>
      <v-card-title primary-title>
        <v-layout>
          <v-flex xs12 sm6 class="form-control text-xs-right" style="display: inherit;">
            <div class="input-icons">
              <i class="fa fa-search icon"></i>
              <input
                @keyup.enter="
                  pageNumberIntent = 1
                  getIntent()
                "
                type="text"
                v-model="search"
                class="form-control"
                :placeholder="$t('Search Conversation Name')"
                style="margin-bottom: 10px"
              />
              <v-btn v-show="search.length > 0" @click="clearSearch" icon class="icon-close">
                <i class="fa fa-close"></i
              ></v-btn>
            </div>
            <v-btn
              @click="
                pageNumberIntent = 1
                getIntent()
              "
              color="primary"
            >
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn flat fab small @click="$emit('close')"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider />
      <v-card-text style="max-height: 600px">
        <div v-if="loading" class="pt-2 pb-2">
          <div class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </div>
        <template v-else>
          <v-pagination
            :total-visible="showsize"
            v-model="pageNumberIntent"
            @input="getIntent"
            :length="pageCountIntent"
          ></v-pagination>
          <div
            class="z-border-red ma-2"
            v-for="intent in filterIntent"
            :key="'intent_' + intent.id"
          >
            <div class="pa-2">
              <v-layout wrap row class="mb-0">
                <v-flex xs6>
                  <template v-if="intent.intentname == '{default}'">{{
                    $t('Default Conversation')
                  }}</template>
                  <template v-else-if="intent.intentname == '{welcome}'">{{
                    $t('Welcome Message')
                  }}</template>
                  <template v-else-if="intent.intentname == '{default_comment_to_inbox}'">{{
                    $t('More Comment to Inbox')
                  }}</template>
                  <template v-else>{{ intent.intentname }}</template>
                </v-flex>
                <v-flex xs6 class="text-xs-right">
                  <toggle-button
                    class="mt-2"
                    :value="intent.linenoti_status"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="onChangeLinenotifyStatus(intent.id)"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </v-flex>
              </v-layout>
            </div>
            <v-divider />
            <div class="pa-2">
              <v-layout wrap class="">
                <v-flex xs12>
                  <div class="form-control">
                    <input
                      type="text"
                      v-model="intent.linenoti_text"
                      :placeholder="$t('Message')"
                      class="mb-0"
                      maxlength="250"
                      @change="onChangeLinenotifyText(intent.id)"
                    />
                  </div>
                </v-flex>
              </v-layout>

              <select-specific-linenotify
                class="mt-3"
                :key="intent.linenoti_spec_ids"
                v-model="intent.linenoti_spec_ids"
                @onSave="onChangeSpecifyLineNotify(intent.id, $event)"
              ></select-specific-linenotify>
            </div>
          </div>
          <v-pagination
            :total-visible="showsize"
            v-model="pageNumberIntent"
            @input="getIntent"
            :length="pageCountIntent"
          ></v-pagination>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn outline color="grey" @click="$emit('close')">{{ $t('cancel') }}</v-btn>
        <v-btn depressed color="primary" @click="onSaveLineNotify">{{ $t('Save') }}</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'

import SelectSpecificLinenotify from './SelectSpecificLinenotify'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  props: {
    value: {
      default: false
    },
    type: {
      default: 'conversation'
    }
  },
  data: function() {
    return {
      loading: true,
      search: '',
      intents: [],
      default_intent: undefined,
      showsize: 15,
      pageNumberIntent: 1,
      pageCountIntent: 0
    }
  },
  components: { ToggleButton, ModalDialog, SelectSpecificLinenotify },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterIntent: function() {
      var vm = this

      return vm.intents
    }
  },
  mounted: function() {
    var vm = this
    vm.loading = true
    vm.getIntent().then(function() {
      vm.loading = false
    })
  },
  methods: {
    onChangeSpecifyLineNotify(id) {
      var vm = this
      var findIndex = vm.intents.findIndex(function(el) {
        return el.id == id
      })
      if (findIndex > -1) {
        vm.intents[findIndex].isEdit = true
        this.$set(this.intents[findIndex], isEdit, true)
      }
    },
    onChangeLinenotifyStatus: function(id) {
      var vm = this
      var findIndex = vm.intents.findIndex(function(el) {
        return el.id == id
      })
      if (findIndex > -1) {
        vm.intents[findIndex].isEdit = true
        vm.intents[findIndex].linenoti_status = !vm.intents[findIndex].linenoti_status
      }
    },
    onChangeLinenotifyText: function(id) {
      var vm = this
      var findIndex = vm.intents.findIndex(function(el) {
        return el.id == id
      })
      if (findIndex > -1) {
        vm.intents[findIndex].isEdit = true
      }
    },
    onSaveLineNotify: async function() {
      this.$store.dispatch('loading')
      await this.saveAllLineNotify()
      this.$store.dispatch('loading')
      this.$emit('close')
    },
    saveAllLineNotify: async function() {
      try {
        if (this.filterIntent) {
          var result = await Promise.all(
            this.filterIntent.map(intent => this.precessSaveLineNotify(intent))
          )
        }
        return result
      } catch (error) {
        console.log(error)
        return error
      }
    },
    precessSaveLineNotify: async function(intent) {
      return await this.saveLineNotify(intent)
    },
    saveLineNotify: function(intent) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (intent.isEdit) {
          let data = {
            ...intent,
            pageid: vm.selectedBot.pageid,
            a_type: 'json',
            isShow: true
          }
          data['id'] = intent.id
          api.editIntent(data, function(error, response) {
            if (error) {
              if (response.result === 'DUPLICATE_INTENT_NAME') {
                vm.$swal({
                  title: vm.$t('Error'),
                  type: 'error',
                  text: vm.$t('duplicate_conversation_name'),
                  confirmButtonText: vm.$t('Confirm')
                })
              }
              reject(error)
            }

            resolve()
          })
        } else {
          reject()
        }
      })
    },
    clearSearch() {
      const vm = this
      vm.search = ''
      vm.getIntent()
    },
    getIntent: function() {
      let vm = this
      vm.loading = true
      let data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.showsize,
        offset: (vm.pageNumberIntent - 1) * vm.showsize,
        page_intent: vm.type === 'conversation' ? 'conversation' : 'comment',
        search_intent: vm.search || '',
        sort_by: 'intentname',
        sort_type: 'asc',
        intent_name: '["{general_intent=1}","{welcome}","{default}","{default_comment_to_inbox}"]'
      }

      return new Promise((resolve, reject) => {
        api.getIntent(data, function(error, response) {
          if (error) {
            vm.loading = false
            reject(error)
          }
          if (response.data) {
            vm.loading = false
            vm.intents = []
            vm.pageCountIntent = Math.ceil(response.total_count / vm.showsize)
            var default_intent = null
            var isFoundDefault = false
            $.each(response.data, function(index, val) {
              var intent = val
              intent.isEdit = false
              intent.ableToDelete = true
              if (vm.type == 'conversation' && intent.context_in != 'comment') {
                if (intent.intentname == '{default}') {
                  isFoundDefault = true
                  intent.ableToDelete = false
                  intent.intentname = '{default}'
                  default_intent = intent
                } else if (intent.intentname == '{welcome}') {
                  intent.intentname = '{welcome}'
                  vm.intents.push(intent)
                } else {
                  vm.intents.push(intent)
                }
              } else if (vm.type == 'replycomment' && intent.context_in == 'comment') {
                if (intent.intentname == '{default_comment_to_inbox}') {
                  isFoundDefault = true
                  intent.ableToDelete = false
                  intent.intentname = '{default_comment_to_inbox}'
                  default_intent = intent
                } else {
                  vm.intents.push(intent)
                }
              }
            })

            if (isFoundDefault) {
              vm.intents.push(default_intent)
            }
            resolve()
          } else {
            vm.loading = false
            reject()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.primaryButton {
  margin-left: 0;
  margin-right: 0;
}
.intentmax {
  font-size: 22px;
}
.input-icons {
  display: contents;
  i {
    position: absolute;
  }
  .icon-close {
    color: gray;
    padding: 16px;
    margin-left: -40px;
  }
  .icon {
    padding: 16px;
    min-width: 50px;
  }
  input {
    padding-left: 35px !important;
    padding-right: 35px !important;
    width: 100%;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/billing/ManageSingleLineNotify.vue